import { useState, useEffect } from 'react';
import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';

const EmailInputElement = ({ element }) => {
    const {
        formData,
        getCurrentScreen,
        updateFormData,
        updateGlobalAnswer,
        isValidEmail,
        normalizeEmailInput,
        setScreenValidation
    } = useOnboarding();

    const style = applyStyles(element);
    const currentScreen = getCurrentScreen();
    const [email, setEmail] = useState('');
    const [hasError, setHasError] = useState(false);
    const [touched, setTouched] = useState(false);

    // Initialize from saved data
    useEffect(() => {
        const savedEmail = formData.get('email');
        const normalized = savedEmail ? normalizeEmailInput(savedEmail) : '';
        if (savedEmail) {
            setEmail(normalized);
            if (normalized !== savedEmail) {
                updateFormData('email', normalized);
            }
            setTouched(true);
            console.log('savedEmail', savedEmail);
        }
        
        // Always validate if field is required
        if (element.required) {
            console.log('element.required', element.required, normalized, isValidEmail(normalized));
            const isValid = normalized && isValidEmail(normalized);
            setScreenValidation(isValid);
            setTimeout(() => {
                console.log('screenValidation');
                setScreenValidation(isValid);
            }, 100);
        }

        console.log('screenValidation');

    }, [formData, element.required, isValidEmail, normalizeEmailInput, setScreenValidation, updateFormData]);

    const handleChange = (e) => {
        const value = normalizeEmailInput(e.target.value);
        setEmail(value);
        updateFormData('email', value);

        if (currentScreen?.name) {
            updateGlobalAnswer(currentScreen.name, {
                text: value,
                value: value,
                elementName: 'email'
            });
        }

        // Check if email is valid
        const isValid = value.length > 0 && isValidEmail(value);

        // Update screen validation if field is required
        if (element.required) {
            setScreenValidation(isValid);
        }

        // Validate in real-time if field was touched
        if (touched && value.length > 0) {
            setHasError(!isValidEmail(value));
        } else {
            setHasError(false);
        }
    };

    const handleBlur = () => {
        setTouched(true);
        if (email && !isValidEmail(email)) {
            setHasError(true);
        } else if (!email) {
            setHasError(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.target.blur();
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <div className="element-email-input-container" style={style}>
            <form onSubmit={handleSubmit} action="#" noValidate>
                <input
                    type="email"
                    className={`element-email-input ${hasError ? 'error' : ''}`}
                    placeholder={element.placeholder || 'Enter your email'}
                    value={email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyDown}
                    enterKeyHint="done"
                    inputMode="email"
                    autoComplete="email"
                />
            </form>
            {hasError && touched && (
                <div style={{
                    color: '#ff6b6b',
                    fontSize: '12px',
                    marginTop: '8px',
                    textAlign: 'left'
                }}>
                    Please enter a valid email address
                </div>
            )}
        </div>
    );
};

export default EmailInputElement;

